import styled from 'styled-components'

export const TransparencyPageContainer = styled.div`
  min-height: 100vh;
  background: white;
`

export const TransparencyPageHeader = styled.div`
  background: linear-gradient(135deg, var(--vo-escuro) 0%, var(--vo-escuro-2) 100%);
  padding: 56px 24px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
`

export const TransparencyPageContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 24px 80px;
`

export const SectionTitle = styled.h2`
  font-family: 'Rubik', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--vo-ink);
  margin: 0 0 16px;
  letter-spacing: -.01em;
`
